module.exports = __webpack_public_path__ + "d9df654d72e18da1f27f8c970aaf32ec.fbx";